/**
 * 运行时配置文件
 */
import './i18n';

import jojoAccount from '@jojo/account-sdk';
import SentryConfig from '@woulsl/sentry-config';
import sensors from '@woulsl-tools/sensors';
import React from 'react';
import { Cookies } from 'react-cookie';
import VConsole from 'vconsole';

import {
  envName,
  isJoJoUp,
  isMatrix,
  JOJO_READ_URL,
  MALL_SERVICE_BASE,
  UC_DEBUG_API_DOMAIN
} from '@/config/base';
import Providers from '@/models';
import { REQUEST_SESSION_EXPIRE, STORAGE_REQUEST_SESSION_KEY } from '@/utils/constants';
import Exposure from '@/utils/sensorsPlugin/exposure';
import { session, storage } from '@/utils/storage';
import { isWXBrowser } from '@/utils/util';

// 单例cookie
const cookies = new Cookies();
const isOfflinePackage = process.env.IS_OFFLINE_PACKAGE;
// growing io 统计，应用首次加载时执行初始化操作
const domains = 'mall.tinman.cn,mall.fat.tinman.cn,jjsc.tinman.cn,jjsc.fat.tinman.cn'; // 需要gio统计的域名列表
const { host } = window.location;
if (domains.indexOf(host) > 0) {
  gio('init', 'ae926239b5ed7601', host, {
    debug: false,
    platform: isWXBrowser() ? 'wxwv' : 'Web'
  });
  gio('send');
}

jojoAccount.config({
  envName, // 测试环境
  hosts: {
    ucHost: UC_DEBUG_API_DOMAIN,
    serverHost: JOJO_READ_URL,
    apiHost: MALL_SERVICE_BASE
  }
  // todo
  // hosts: {
  //   apiHost: window.location.origin
  // },
  // packageName: 'mp.tinman.JoJoRead',
  // authToken: '3137313a615f743a663a31303032353833383a32393830323136353634'
});

/**
 * 存储链接上携带的平台信息 ios
 */
const operationChannelEnum: any = {
  huawei: 1,
  appstore: 2
};
const { search } = window.location;
const params = new URLSearchParams(search);
const operationChannel: any = params.get('jointOperationsChannel');
storage.set('operationChannel', operationChannelEnum[operationChannel] || '');

const getSentryDNS = () => {
  if (isMatrix) {
    // 矩阵不需要上报sentry
    return '';
  } else {
    if (isOfflinePackage) {
      return 'https://4ff399af09464f3485506a5272bb5cb9@sentry.tinman.cn/89';
    } else {
      return 'https://40fee53cddfb46d384fd26e0bfb45c9a@sentry.tinman.cn/36';
    }
  }
};

SentryConfig({
  dsn: getSentryDNS(),
  // 错误采样率，B端项目建议为1，C端项目可以不配置（默认为0.5）
  sampleRate: 0.5,
  // 请求采样率，B端项目建议为1，C端项目可以不配置（默认为0.5）
  tracesSampleRate: 0.5,
  environment: envName as any
});

// 神策全局配置
(function () {
  const ua = window.navigator.userAgent;
  let platform = '其他';
  const isWx = /MicroMessenger/i.test(ua);
  const isMiniApp = /miniprogram/i.test(ua);
  if (isWx && isMiniApp) {
    platform = '微信小程序';
  } else if (isWx) {
    platform = '微信内';
  } else if (/JoJoVersion/i.test(ua)) {
    platform = 'APP内';
  }

  let server_url = '';
  if (envName === 'pro') {
    if (isJoJoUp) {
      server_url = 'https://sensors.tinman.cn/sa?project=jojoup';
    } else if (isMatrix) {
      server_url = 'https://sensors.tinman.cn/sa?project=jojo_matrix';
    } else {
      server_url = 'https://sensors.tinman.cn/sa?project=production';
    }
  } else {
    server_url = 'https://sensors.tinman.cn/sa?project=default';
  }

  window.sensorsExpoSure = sensors.use(Exposure, {
    area_rate: 0,
    stay_duration: 0,
    repeated: true
  });

  // 注册sensors
  sensors.tinmanSensorsInit({
    lob: 'mall',
    env_name: envName || '',
    // show_log: "<%= context.ENV_DEBUG %>",
    show_log: false,
    server_url, // 可手动配置神策服务地址，需区分环境
    autoTrackSet() {
      sensors.quick('isReady', function () {
        // 注册公共属性
        const registerParams = {
          custom_platform: platform
        };

        sensors.registerPage(registerParams);
      });
      const isAutoTrackPath =
        [
          '/item/detail',
          '/home',
          '/order/create',
          '/order/pay',
          '/order/success',
          '/address/list',
          '/address/edit',
          '/subscribe/list',
          '/subscribe/pay',
          '/subscribe/detail',
          '/shop/index',
          '/shop/notice',
          '/shop/notice/detail',
          '/shop/banner',
          '/item/subscribeDetail',
          '/order/invoiceDetails'
        ].indexOf(window.location.pathname) > -1;
      if (isAutoTrackPath) {
        return false;
      }
      return true;
    }
  });

  window.sensors = sensors;
})();

if (['fat', 'dev', 'uat'].includes(envName as string)) {
  (() => new VConsole())();
}

export function render(oldRender: Function) {
  const rsk = session.get(STORAGE_REQUEST_SESSION_KEY);
  if (!rsk) {
    const cks = cookies.getAll() || {};
    const ckeys = Object.keys(cks);
    ckeys.forEach((key) => {
      cookies.remove(key);
    });
    session.set(STORAGE_REQUEST_SESSION_KEY, Date.now(), REQUEST_SESSION_EXPIRE);
  }

  oldRender();
}

/**
 * 包裹根组件
 * @param container
 */
export function rootContainer(container: any) {
  return React.createElement(Providers, null, container);
}
